<template>
  <config-base-comp
    :show-plan-details="showPlanDetails"
    class="opc-sdk-uc"
    @view-details="viewDetails">
    <div slot="config" class="opc-sdk-uc__config">
      <sdk-credit-group
        v-model="value"
        :category-list="creditCategoryList"
        :select-group-title="$t('billing.video_sdk_uc.select_plan_title')"
        :ax-select-group-title="title"
        :trackingPlanName="trackingPlanName"
        :unit="planUnitMap.credits"
        group-category-key="plan_code"
        @switchCategoryAction="switchCategoryAction"
      />
    </div>
     <div slot="footer" class="opc-sdk-uc__footer">
      <span class="opc-sdk-uc__footer--desc" v-html="$t('billing.video_sdk_uc.more_credits_than_trial_desc',[credits,switchLink])"></span>
    </div>
  </config-base-comp>
</template>

<script type="text/jsx">
import ConfigBase from '@/components/config-base';
import mxPlanConfig from '@/plans/VIDEO_SDK_UC/mx/buy-now-trial';
import ConfigCustomGroup from '@/components/service/config-custom-group/index';
import { plansof } from '@/utils/chain';
import { mapActions, mapGetters } from 'vuex';
import { getPlanUnitWithQuantity, planUnitMap } from '@/common/product-unit';
import SaveCount from '@/components/save-count';
import { isEmptyVal } from '@/utils';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import PlanDetails from '@/plans/VIDEO_SDK_UC/dialog/plan-details';
import CreditRateFeature from '@/plans/VIDEO_SDK_UC/dialog/credit-rate-feature';
import { trackingPlanTypes,FREETRIAL_PLANCODE, DEFAULT_TRIAL_CREDIT, DEFAULT_TRIAL_MONTH} from '@/common/constants';
import { getDefaultFlowType } from '@/common/service/page-config';
import UsageTypeMixins from '@/views/checkout/address/mx-usage-type';

const ConfigBaseComp = {
  name: 'sdk-uc-base',
  extends: ConfigBase,
  mixins: [mxPlanConfig],
  props: {
    showPlanDetails: Boolean,
    planDetailsLabel: String,
  },
  data() {
    return {
      showLearnMore: false,
      unit: planUnitMap.credits,
      itemIcon: require('@/assets/plans/checked_checkboxes-green.svg'),
    };
  },
  computed:{
    planList() {
      return plansof(this.planMapFlat).type(this.planType).get();
    },
    targetPlan() {
      const targetPlan = this.planList?.find(
        plan => plan.plan_code === FREETRIAL_PLANCODE.VIDEO_SDK
      );
      if (!targetPlan) return [];
      return targetPlan
    },
    credits(){
      return this.targetPlan?.credit || DEFAULT_TRIAL_CREDIT
    }
  },
  methods: {
    showCreditRate() {
      this.creditRateFeatureDialog.confirm();
      this.$tracking.buyInteraction(
        'credit rates selected',
        trackingPlanTypes.VIDEO_SDK_UC,
      );
    },
    mx_renderLicense() {
      return '';
    },
    mx_renderCycle() {
      return ''
    },
    mx_renderHeadRight() {
      return <div class="opc-zm-base-card__head-right">
        {this.mx_renderTitle()}
        {this.mx_renderSelectedList()}
        {this.mx_renderDetailBtn()}
        <div class="opc-sdk-uc__desc">
          <p class="opc-sdk-uc__desc-text">
            <img src={this.itemIcon} alt="Included" />
            {this.$t('billing.video_sdk_uc.free_credits',[this.credits])}
            <zm-button data-testid="checkout-button-87" 
              type="link" 
              onClick={this.showCreditRate} 
              class="opc-zm-base-card__main--desc__btn">
              {this.$t('billing.video_sdk_uc.view_credit_rates_cta')}
            </zm-button>
          </p>
          <p class="opc-sdk-uc__desc-text">
            <img src={this.itemIcon} alt="Included"/>
              {this.$t('billing.video_sdk_uc.access_service')}
          </p>
          <p class="opc-sdk-uc__desc-text-note">{this.$t('billing.video_sdk_uc.unused_exp',[this.targetPlan?.trialMonth || DEFAULT_TRIAL_MONTH])}</p>
        </div>
      </div>
    },
  },
  created() {
    this.creditRateFeatureDialog = new ServiceConfirm(CreditRateFeature);
  },
};

const SdkCreditGroup = {
  extends: ConfigCustomGroup,
  components: { SaveCount },
  methods: {
    mx_renderGroupCol(item = {}) {
      const { plan = {}, disabled } = item;

      return <zm-radio data-testid="checkout-radio-88" disabled={disabled} label={plan.plan_code}>
        <p class="opc-custom-group__plan__title">
          <span>{plan.credit} {getPlanUnitWithQuantity(planUnitMap.credits)}</span>
        </p>
        <p class="opc-custom-group__plan__price opc-sdk-uc__plan_price">
          {this.$t('billing.video_sdk_uc.free')}
        </p>
      </zm-radio>;
    },
  },
};

export default {
  components: {
    ConfigBaseComp,
    SdkCreditGroup,
  },
  mixins: [mxPlanConfig, UsageTypeMixins],
  data() {
    return {
      value: '',
      planUnitMap,
      switchLink: '/opc/buy/config?plan=zsdkuc&usageType=business'
    };
  },
  computed: {
    ...mapGetters(['planMapFlat', 'getSelectedPlans']),
    showPlanDetails() {
      return true;
    },
    planList() {
      return plansof(this.planMapFlat).type(this.planType).get();
    },
    creditCategoryList() {
      const targetPlan = this.planList?.find(
        plan => plan.plan_code === FREETRIAL_PLANCODE.VIDEO_SDK
      );

      if (!targetPlan) return [];

      return [
        {
          plan: targetPlan,
          disabled: false,
        },
      ];
    },
    selectedPlan() {
      return plansof(this.getSelectedPlans).type(this.planType).get(0);
    },
    credits(){
      return this.selectedPlan?.credit || DEFAULT_TRIAL_CREDIT
    }
  },
  methods: {
    ...mapActions(['switchSelectPlanAction']),
    viewDetails() {
      this.planDetailsDialog.confirm({
        title: this.title,
      });

      this.$tracking.buyInteraction(
        'plan details selected',
        trackingPlanTypes.VIDEO_SDK_UC,
      );
    },
    switchCategoryAction(oldPlan, newPlan) {
      this.switchSelectPlanAction([oldPlan?.plan_code, {
        ...newPlan,
        cartInfo: {
          selected_number: 1,
        },
      }]);
      this.$tracking.buyInteraction(trackingPlanTypes.VIDEO_SDK_UC,newPlan?.credit+' credits');
    },
    handleSwitch() {
      const type = getDefaultFlowType();
      this.$tracking.buyInteraction('explore other plans', `${this.trackingPlanName} - switch now to pay as you go`);
      location.href = `/opc/buy?plan=litesdk&type=${type}`;
    },
  },
  created() {
    if (!isEmptyVal(this.selectedPlan)) {
      this.value = this.selectedPlan?.plan_code;
    }

    this.planDetailsDialog = new ServiceConfirm(PlanDetails);
  },
};
</script>

<style lang="scss">
.opc-sdk-uc {
  &__plan_price{
    font-size: 22px;
    font-weight: 700;
  }
  &__desc{
    margin-top: 18px;
    p{
      img {
          vertical-align: top;
          margin-right: 5px;
      }
    }
    &-text-note{
      color: #6E7680;
      margin-top: 14px;
    }
  }
  &__config {

  }

  .opc-zm-base-card__main__footer {
    margin-top: 32px;
  }

  &__group {
    text-align: left;
    &--desc {
      margin: 5px 0;
      font-weight: 400;
      font-size: 14px;
      font-style: normal;
      line-height: 150%;
      color: var(--day-foreground-foreground-ada, #666487);
    }
  }

  &__footer {
    text-align: left;

    &--desc, &--switch {
      font-size: 14px;
      font-style: normal;
      line-height: 150%;
    }

    &--desc {
      font-weight: 400;
      color: var(--day-foreground-foreground-ada, #666487);
    }

    &--switch {
      &.zm-button.zm-button--link {
      margin-left: 4px;
      color: var(--day-semantic-sentiment-info, #0B5CFF);
      font-weight: 500;
      vertical-align: baseline;
    }
  }
}
}
</style>
